// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { OrganizationProvider } from './contexts/OrganizationContext';
import { ScreenProvider } from './contexts/ScreenContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import PlayerPage from './pages/PlayerPage';
import FeatureMarketplace from './components/FeatureMarketplace';
import WidgetTestPage from './pages/WidgetTestPage';
import VerifySuccess from './components/VerifySuccess';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancelled from './pages/PaymentCancelled';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Support from './pages/Support';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Imprint from './pages/Imprint';
import ResetPassword from './components/ResetPassword';
import RequestPasswordReset from './components/RequestPasswordReset';
import Pricing from './pages/Pricing';
import ConnectScreen from './pages/ConnectScreen';
import WaitingRoom from './pages/WaitingRoom';
import Analytics from './pages/Analytics';
import ContentStudio from './components/ContentStudio/ContentStudio';

function App() {
  return (
    <ThemeProvider>
      <OrganizationProvider>
        <ScreenProvider>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true
            }}
          >
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/en" element={<LandingPage lang="en" />} />
              <Route path="/fr" element={<LandingPage lang="fr" />} />  
              <Route path="/it" element={<LandingPage lang="it" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/verify-success" element={<VerifySuccess />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/request-password-reset" element={<RequestPasswordReset />} />
              <Route path="/pricing" element={<Pricing />} />
              
              {/* Screen Connection (Public - no auth required) */}
              <Route path="/connect" element={<ConnectScreen />} />
              <Route path="/waiting" element={<WaitingRoom />} />

              {/* Player - PUBLIC (screens/displays access without login) */}
              <Route path="/player/:uuid" element={<PlayerPage />} />
              
              {/* Legal Pages */}
              <Route path="/support" element={<Support />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/imprint" element={<Imprint />} />
              
              {/* Dashboard - Protected Route */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              
              {/* Marketplace & Widgets - Protected */}
              <Route path="/marketplace" element={
                <ProtectedRoute>
                  <FeatureMarketplace />
                </ProtectedRoute>
              } />
              
              <Route path="/widget/test/:instanceId" element={
                <ProtectedRoute>
                  <WidgetTestPage />
                </ProtectedRoute>
              } />
              
              {/* Analytics - Protected */}
              <Route path="/analytics" element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              } />

              {/* Content Studio - Protected */}
<Route path="/content-studio" element={
  <ProtectedRoute>
    <ContentStudio />
  </ProtectedRoute>
} />
              
              {/* Payment - Protected */}
              <Route path="/payment-success" element={
                <ProtectedRoute>
                  <PaymentSuccess />
                </ProtectedRoute>
              } />
              
              <Route path="/payment-cancelled" element={
                <ProtectedRoute>
                  <PaymentCancelled />
                </ProtectedRoute>
              } />
              
              {/* Catch-all redirect to landing page */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </BrowserRouter>
        </ScreenProvider>
      </OrganizationProvider>
    </ThemeProvider>
  );
}

export default App;